module.exports = __webpack_public_path__ + "static/media/social_linkedin_gray.6ccf1bf2.svg";